import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Store } from '@ngrx/store';
import { passwordActions } from '../../store/password/password.actions';
import { ActivatedRoute } from '@angular/router';
import { map, Observable } from 'rxjs';
import { PasswordResetStatus } from '../../store/password/password.state';
import { selectResetPasswordStatus } from '../../store/password/password.selectors';
import { createPasswordsMatchValidator } from '../../services/helpers/passwordsMatchValidator';
import { createPasswordFormControl } from '../../services/helpers/createPasswordFormControl';

interface ResetPasswordFormData {
  password: FormControl<string>;
  confirmation: FormControl<string>;
}

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password-view.component.html',
  styleUrls: ['./reset-password-view.component.scss'],
  standalone: false
})
export class ResetPasswordViewComponent implements OnInit {
  protected form: FormGroup<ResetPasswordFormData>;
  protected status$: Observable<PasswordResetStatus>;

  constructor(private store: Store, private route: ActivatedRoute) {
    this.form = this.createForm();
  }

  ngOnInit(): void {
    this.status$ = this.store.select(selectResetPasswordStatus);
  }

  private createForm(): FormGroup<ResetPasswordFormData> {
    const passwordControl = createPasswordFormControl('');
    const confirmationControl = new FormControl<string>('', { updateOn: 'change', validators: [Validators.required] });

    return new FormGroup(
      {
        password: passwordControl,
        confirmation: confirmationControl
      },
      {
        validators: [createPasswordsMatchValidator('password', 'confirmation')]
      }
    );
  }

  send(): void {
    if (this.form.valid) {
      this.route.queryParams
        .pipe(
          map(params => {
            const email: string = params['email'];
            const token: string = params['token'];

            this.store.dispatch(
              passwordActions.reset_password_request_start({ email, token, password: this.form.controls.password.value })
            );
          })
        )
        .subscribe();
    }
  }

  protected readonly PasswordResetStatus = PasswordResetStatus;
}
